/*
 *
 * AppOverview Reducer
 *
 */
import produce from 'immer';
import * as actionTypes from './constants';
export var initialState = {
    members: [],
    members_loading: false,
    analytics: [],
    analytics_loading: false,
    analytics_error: false,
    analytics_meta: {},
    usage: [],
    usage_loading: false,
    usage_error: false,
    usage_meta: {},
    users: [],
    users_loading: false,
    users_error: false,
    users_meta: {},
    time: [],
    time_loading: false,
    pv: [],
    pv_loading: false,
    view_usage: [],
    view_usage_loading: false,
    view_usage_error: false,
    dataset_usage: [],
    dataset_usage_loading: false,
    dataset_usage_error: false,
};
function analyticsReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case actionTypes.LOAD_INSTALL_ANALYTICS_REQUEST:
                state.analytics_loading = true;
                state.analytics_error = false;
                break;
            case actionTypes.LOAD_INSTALL_ANALYTICS_SUCCESS:
                state.analytics_loading = false;
                state.analytics_error = false;
                state.analytics = action.analytics;
                state.analytics_meta = action.meta;
                break;
            case actionTypes.LOAD_INSTALL_ANALYTICS_FAILED:
                state.analytics_loading = false;
                state.analytics = [];
                state.analytics_error = true;
                break;
            case actionTypes.LOAD_USAGE_ANALYTICS_REQUEST:
                state.usage_loading = true;
                state.usage_error = false;
                break;
            case actionTypes.LOAD_USAGE_ANALYTICS_SUCCESS:
                state.usage_loading = false;
                state.usage_error = false;
                state.usage = action.usage;
                state.usage_meta = action.meta;
                break;
            case actionTypes.LOAD_USAGE_ANALYTICS_FAILED:
                state.usage_loading = false;
                state.usage = [];
                state.usage_error = true;
                break;
            case actionTypes.LOAD_APP_TIME_ANALYTICS_REQUEST:
                state.time_loading = true;
                break;
            case actionTypes.LOAD_APP_TIME_ANALYTICS_SUCCESS:
                state.time_loading = false;
                state.time = action.time;
                break;
            case actionTypes.LOAD_PV_ANALYTICS_REQUEST:
                state.pv_loading = true;
                break;
            case actionTypes.LOAD_PV_ANALYTICS_SUCCESS:
                state.pv_loading = false;
                state.pv = action.pv;
                break;
            case actionTypes.LOAD_USERS_ANALYTICS_REQUEST:
                state.users_loading = true;
                state.users_error = false;
                break;
            case actionTypes.LOAD_USERS_ANALYTICS_SUCCESS:
                state.users_loading = false;
                state.users_error = false;
                state.users = action.users;
                state.users_meta = action.meta;
                break;
            case actionTypes.LOAD_USERS_ANALYTICS_FAILED:
                state.users_loading = false;
                state.users = [];
                state.users_error = true;
                break;
            case actionTypes.LOAD_VIEW_USAGE_ANALYTICS_REQUEST:
                state.view_usage_loading = true;
                state.view_usage_error = false;
                break;
            case actionTypes.LOAD_VIEW_USAGE_ANALYTICS_SUCCESS:
                state.view_usage_loading = false;
                state.view_usage_error = false;
                state.view_usage = action.view_usage;
                break;
            case actionTypes.LOAD_VIEW_USAGE_ANALYTICS_FAILED:
                state.view_usage_loading = false;
                state.view_usage = [];
                state.view_usage_error = true;
                break;
            case actionTypes.LOAD_DATASET_USAGE_ANALYTICS_REQUEST:
                state.dataset_usage_loading = true;
                state.dataset_usage_error = false;
                break;
            case actionTypes.LOAD_DATASET_USAGE_ANALYTICS_SUCCESS:
                state.dataset_usage_loading = false;
                state.dataset_usage_error = false;
                state.dataset_usage = action.dataset_usage;
                break;
            case actionTypes.LOAD_DATASET_USAGE_ANALYTICS_FAILED:
                state.dataset_usage_loading = false;
                state.dataset_usage = [];
                state.dataset_usage_error = true;
                break;
            case actionTypes.GET_ORGANIZATION_MEMBERS_REQUEST:
                state.members_loading = true;
                break;
            case actionTypes.GET_ORGANIZATION_MEMBERS_SUCCESS:
                state.members = action.members;
                state.members_loading = false;
                break;
            case actionTypes.GET_ORGANIZATION_MEMBERS_FAILURE:
                state.members_loading = false;
                break;
            default:
                break;
        }
    });
}
export default analyticsReducer;
